module.exports = __webpack_public_path__ + "img/相続のせんせいでできること.580e23ec.png";